import React from "react";
import getField from "../get.field";
import styled from "styled-components";
import {IconFilters} from "../../../icons";
import {ButtonWithAccordion} from "../../../button";
import {useTranslation} from "react-i18next";


const FiltersPanelCont = styled.div`
    width: 100%;
    margin-bottom: 25px;
    display: flex;
    justify-content: space-between;
`

const FilterFieldBox = styled.div`
    min-width: 200px;
    margin-bottom: -1rem; //TODO: check if necessary after redesign all filter* components
`

const FiltersSubmitBtnCont = styled.div`
    display: flex;
    align-items: flex-end;
		gap: 12px;
`

const ResetBtnBox = styled.div`
    
`

const SubmitBtnBox = styled.div`
    
`

export const FiltersPanel = ({
															 item,
															 formFieldProps,
															 errors,
															 initialValues,
															 i,
															 itemNamePrefix,
															 submitBtn,
															 resetBtn,
														 }) => {

	/*console.log('FiltersPanel: ', {
		item,
		formFieldProps,
		errors,
		initialValues,
		i,
		itemNamePrefix}
	);*/
	const {t} = useTranslation()

	return (
		<FiltersPanelCont>
			<ButtonWithAccordion
				btnIcon={<IconFilters size={20}/>}
				btnTitle={t(`filter.panel_button`)}
				isOpenInit={false}
			>
				<>
					{item.fields?.map((_field, idx, allColumns) => {
						return <FilterFieldBox key={`${_field.name}-${idx}`} style={{...(_field.styles ?? {})}}>
							{getField(formFieldProps, errors, initialValues, {..._field}, i, itemNamePrefix)}
						</FilterFieldBox>;
					})}

					<FiltersSubmitBtnCont>
						<ResetBtnBox>{resetBtn}</ResetBtnBox>
						<SubmitBtnBox>{submitBtn}</SubmitBtnBox>
					</FiltersSubmitBtnCont>
				</>
			</ButtonWithAccordion>
		</FiltersPanelCont>
	)
}